import script from "./AdministratorProjectRejectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectRejectForm.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectRejectForm.vue?vue&type=style&index=0&id=631297de&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631297de"]])

export default __exports__